import Cookies from 'js-cookie';

const TokenKey = 'token';

export function getToken () {
  return Cookies.get(TokenKey);
}

export function setToken (token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken () {
  return Cookies.remove(TokenKey);
}

export function getLocalStorage (key) {
  return localStorage.getItem(key);
}

export function setLocalStorage (key, val) {
  return localStorage.setItem(key, val);
}
